module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAA2klEQVQ4T2P8v0rPj4GRcSYDI6MEA7ng//8XDH//ZTBGXN7I+H+1/nOKDIM54v//F4yhFyUZ/68x+E+uw9D1MYZcYByKBnLLMTDwqzMwPNuN6iNmDgYGTmkGBmY23CEkoFqE6WV+TQYGAXUGhocbEBrZhRkYxCwZGJhYCAY3cQZKODIw8CkyMKjFQgy8tZiB4ec7rIYTZ6CcHwODpB0Dg4wzxJAnexgYXhylwEC4C+OQXPiWAgMpCkN8scwlzcDARGosE4xH3AqGSk6hVmnz7/8LxjBQaUPl8hAAc3Vr8YmEUjgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/wdkabao_icon.png
// module id = D/kU
// module chunks = 1